<template>
    <v-container fluid fill-height class="console-notification">
        <v-layout justify-center>
            <v-responsive max-width="1280px" width="100%">
                <v-row class="mt-8" justify="center" align="center">
                    <v-col cols="auto" class="pt-0 pb-0 headline text-start">공지사항</v-col>
                    <v-spacer></v-spacer>
                    <!-- <v-col cols="auto" class="pt-0 pb-0">
                        <v-btn class="ma-2" color="secondary" rounded @click="showsSearch = !showsSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                    </v-col> -->
                </v-row>

                <v-data-table :headers="notificationsHeaders" :items="notifications" v-bind="{ loading }" disable-sort disable-pagination hide-default-footer class="mt-4 v-sheet--outlined">
                    <template #[`item.notification`]="{ item }" style="height: auto">
                        <v-row @click="$set(item, 'show', !item.show)">
                            <v-col cols="auto" class="text-start">{{ item.subject }}</v-col>
                            <v-spacer></v-spacer>
                            <v-col cols="auto">
                                <v-icon v-if="!item.show">mdi-chevron-down</v-icon>
                                <v-icon v-else>mdi-chevron-up</v-icon>
                            </v-col>
                        </v-row>
                        <v-expand-transition>
                            <v-row v-show="item.show">
                                <v-col cols="12" class="text-start">
                                    <p v-html="item.content.replace(/\n/g, '<br>')"></p>
                                </v-col>
                            </v-row>
                        </v-expand-transition>
                    </template>
                    <!-- <template #[`item.sites`]="{ item }">
                        <notification-sites :notification="item" />
                    </template> -->
                    <template #[`item.isNotice`]="{ item }">
                        <v-switch v-model="item.isNotice" class="mt-0" hide-details @change="toggleNotice(item)"></v-switch>
                    </template>
                    <template #[`item.createdAt`]="{ item }">
                        {{ item.createdAt.toDate() }}
                    </template>
                    <template #[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="edit(item)"> mdi-pencil </v-icon>
                        <v-icon small @click="remove(item)"> mdi-delete </v-icon>
                    </template>
                </v-data-table>
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12" @input="$router.push({ query: { page } })"></v-pagination>
                <v-fade-transition>
                    <v-overlay v-show="loading">
                        <v-progress-circular indeterminate size="100" width="5" />
                    </v-overlay>
                </v-fade-transition>

                <v-dialog v-model="notificationDialog" max-width="820px" persistent>
                    <template #activator="{ on }">
                        <v-btn v-on="on" bottom color="accent" dark fab fixed right @click="create">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <v-card v-if="notificationDialog" v-bind="{ loading }">
                        <v-card-title>
                            <span v-if="!editItem._id" class="subtitle-1">공지사항 등록</span>
                            <span v-else class="subtitle-1">공지사항 수정</span>
                        </v-card-title>
                        <v-card-text>
                            <v-row class="mt-3">
                                <v-col class="py-0">
                                    <v-text-field v-model="editItem.subject" label="제목" persistent-placeholder hide-details></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" md="4" class="py-0">
                                    <v-select v-model="editItem.sites" multiple :items="sites" persistent-placeholder item-text="text" item-value="value" label="사이트" hide-details small-chips />
                                </v-col> -->
                                <v-col class="py-0">
                                    <v-datetime-field v-model="editItem.createdAt" label="생성일" type="date" persistent-placeholder hide-details />
                                </v-col>
                            </v-row>
                            <file-chips-field v-model="editItem.files" label="첨부파일" persistent-placeholder hide-details class="mt-4" />
                            <div class="caption mt-4 mb-1">내용</div>
                            <naver-smarteditor v-model="editItem.content" rows="10"></naver-smarteditor>
                        </v-card-text>

                        <v-card-actions>
                            <v-switch v-model="editItem.isNotice" class="ma-0 py-0 px-4" hide-details>
                                <span slot="label" class="subtitle-2">상단고정</span>
                            </v-switch>
                            <v-spacer></v-spacer>
                            <v-btn text v-bind="{ loading }" @click="close">취소</v-btn>
                            <v-btn color="primary" text v-bind="{ loading }" @click="save(editItem)">저장</v-btn>
                        </v-card-actions>
                        <v-fade-transition>
                            <v-overlay v-show="loading" light color="white">
                                <v-progress-circular indeterminate width="5" size="100" color="primary" />
                            </v-overlay>
                        </v-fade-transition>
                    </v-card>
                </v-dialog>
            </v-responsive>
        </v-layout>
    </v-container>
</template>

<script>
import api from "@/api";

import FileChipsField from "@/components/console/dumb/file-chips-field.vue";
import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import NotificationSites from "@/components/console/center/notification-sites.vue";

const sites = [
    { text: "Y-Knowledge", value: "yknowledge" },
    { text: "Y-Factory", value: "yfactory" },
];

export default {
    components: {
        FileChipsField,
        VDatetimeField,
        NaverSmarteditor,
        NotificationSites,
    },
    name: "Notifications",
    data() {
        return {
            showsSearch: false,
            loading: false,

            page: +(this.$route?.query?.page || 1),
            pageCount: 0,
            limit: 10,

            notificationDialog: false,
            notifications: [],
            notificationsHeaders: [
                {
                    text: "no",
                    align: "center",
                    width: 100,
                    value: "no",
                },
                {
                    text: "공지사항",
                    align: "center",
                    value: "notification",
                },
                // {
                //     text: "사이트",
                //     align: "center",
                //     width: 120,
                //     value: "sites",
                // },
                {
                    text: "작성일자",
                    align: "center",
                    width: 120,
                    value: "createdAt",
                },
                {
                    text: "상단고정",
                    align: "center",
                    width: 80,
                    value: "isNotice",
                },
                {
                    text: "Actions",
                    align: "center",
                    width: 100,
                    value: "actions",
                },
            ],
            editItem: {
                _id: null,
                subject: "",
                content: "",
                sites: null,
                upload: null,
                createdAt: Date.now().toDateTime(),
            },

            defaultItem: {
                _id: null,
                subject: "",
                content: "",
                sites: null,
                upload: null,
                createdAt: Date.now().toDateTime(),
            },
            sites,
        };
    },
    computed: {
        site() {
            return this.$route.query?.site;
        },
    },
    created() {
        this.init();
    },
    watch: {
        page() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                await this.search();
            } catch (error) {
                console.error(error);
            }
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                var { summary, notifications } = await api.console.center.notifications.gets({
                    headers: {
                        skip: (this.page - 1) * this.limit,
                        limit: this.limit,
                    },
                    params: {
                        sites: this.site,
                    },
                });

                for (let notification of notifications) {
                    notification.createdAt = notification.createdAt.toDateTime();
                    notification.no = (this.page - 1) * this.limit + notifications.indexOf(notification) + 1;
                    console.log({ ...notification });
                }

                this.notifications = notifications;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        close() {
            this.notificationDialog = false;
        },

        create() {
            this.editItem = Object.assign({}, this.defaultItem);
            this.notificationDialog = true;
        },

        async edit(notification) {
            let item = { ...notification };
            item.files = await Promise.all([{ url: item.upload }, ...(item.files || [])].filter(({ url }) => url).map(async ({ url }) => await api.getResource(url, true)));
            this.editItem = Object.assign({}, item);
            this.notificationDialog = true;
        },

        async toggleNotice(item) {
            if (this.loading) {
                item.isNotice = !item.isNotice;
                return;
            } else this.loading = true;

            try {
                await api.console.center.notifications.put({ _id: item._id, isNotice: item.isNotice });
            } catch (error) {
                item.isNotice = !item.isNotice;
                console.error(error);
                return;
            } finally {
                this.loading = false;
            }
            await this.search();
        },

        async save({ upload, _files = [], files = [], ...notification }) {
            if (this.loading) return;
            else this.loading = true;
            try {
                notification.upload = null;

                const { post, put } = api.console.center.notifications;
                notification = (await (notification._id ? put(notification) : post({ ...notification, sites: this.site })))?.notification;

                const _notification = notification?._id;
                await Promise.all(_files.map(async (_id) => await api.console.common.files.delete({ _notification, _id })));
                _files = await Promise.all(files.map(async (file, index) => (await api.console.common.files.post({ _notification, index }, file))?.file?._id));

                await put({ _id: _notification, _files, subject: notification.subject, content: notification.content });

                await this.search();
                this.notificationDialog = false;
            } finally {
                this.loading = false;
            }
        },

        async remove(notification) {
            try {
                if (confirm("공지사항을 삭제하시겠습니까?")) {
                    await api.console.center.notifications.delete(notification);
                    await this.search();
                }
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
    },
};
</script>

<style>
.console-notification .v-data-table__mobile-row {
    height: auto !important;
}
</style>
